export default __webpack_public_path__ + "static/placeholder-f7870af4a6fac0ef302f1ba784d4b1ec.png";